export default __webpack_public_path__ + "static/media/add-icon.f73c39fb.svg";